import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { catchError, EMPTY, Observable, of } from 'rxjs';
import { AuthenticationFacade } from '../store/authentication/authentication.facade';

@Injectable({
    providedIn: 'root'
})
export class HttpErrorInterceptor implements HttpInterceptor {
    constructor(
        private authenticationFacade: AuthenticationFacade,
        private router: Router
    ) {}

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(
            catchError((response) => {
                if (response instanceof HttpErrorResponse) {
                    if (response.status === 401) {
                        this.authenticationFacade.authenticationFailed();
                        void this.router.navigate(['/auth/sign-in']);
                        return EMPTY;
                    } else if (response.status === 500) {
                        //TODO: implement toastr
                        return EMPTY;
                    } else {
                        throw response;
                    }
                }
                return of(response);
            })
        );
    }
}
